<template>
  <div>
    <div
      class="col-xs-12 col-sm-10 default-list-contain-sty"
      style="box-shadow: 0 0 0 0;"
      v-show="pageInfo.items.length > 0"
    >
      <!-- title -->
      <div
        class="d-flex justify-content-between align-items-center"
        v-show="modeString !== ''"
      >
        <div class="d-flex align-items-center">
          <h4 class="mb-0 mr-2">{{ modeString }}服務履歷</h4>
          <div class="sr__badge" v-if="!canView && statusString">
            {{ statusString }}
          </div>
        </div>

        <!-- 回列表 -->
        <!-- <b-button
          class="text-white btn-sm"
          variant="info"
          size="md"
          @click="goToList(0)"
        >
          <span>回列表</span>
        </b-button> -->
      </div>

      <hr>

      <!-- page -->
      <div class="rc-addrecord-body">
        <div class="rs-addrecord-orderinfo-title">
          <h5>{{pageInfo.title}}</h5>
        </div>

        <div v-for="(field, index) in pageInfo.items" :key="index">
          <!-- base -->
          <div class="pb-4" v-if="field.mix_type !== 'order'">
            <ServiceRecordItem
              :field="field"
              :disable="disable"
              :canShowTag="canShowTag"
              :recordReviewed="isReviewed"
            ></ServiceRecordItem>
          </div>

          <!-- input mix: order -->
          <div v-if="field.type === 'input_mix' && field.mix_type === 'order'">
            <OrderItem
              :field="field"
              :disable="disable"
              :canShowTag="canShowTag"
              :recordReviewed="isReviewed"
            ></OrderItem>
          </div>

        </div>
      </div>

      <!-- footer -->
      <div class="rc-addrecord-footer">
        <!-- action -->
        <div class="mb-3">
          <div class="d-flex justify-content-between align-items-center">
            <!-- step -->
            <div>
              <!-- 上一步 -->
              <b-button
                class="text-white order-info-btn-sty btn-sm"
                variant="dark"
                size="md"
                @click="goToPreStep"
                v-if="currentStep !== 1 "
                :disabled="this.executing"
              >
                <span>上一步</span>
              </b-button>

              <!-- 下一步 -->
              <b-button
                class="text-white order-info-btn-sty btn-sm"
                variant="dark"
                size="md"
                @click="goToNextStep"
                v-if="currentStep !== pageIdens.length - 1"
                :disabled="this.executing"
              >
                <span v-if="canEdit">儲存並下一步</span>
                <span v-else>下一步</span>
              </b-button>

              <!-- 送審 -->
              <b-button
                class="text-white order-info-btn-sty btn-sm"
                style="width: 73px;"
                variant="info"
                size="md"
                v-if="isLastPage && canEdit"
                @click="toReview"
                :disabled="this.executing"
              >
                <span>送審</span>
              </b-button>

              <!-- 退回 -->
              <b-button
                class="text-white order-info-btn-sty btn-sm"
                style="width: 73px;"
                variant="danger"
                size="md"
                v-if="isLastPage && canReview"
                @click="toReviewCheck"
                :disabled="this.executing"
              >
                <span>退回</span>
              </b-button>

              <!-- 通過 -->
              <b-button
                class="text-white order-info-btn-sty btn-sm"
                style="width: 73px;"
                variant="success"
                size="md"
                v-if="isLastPage && canReview"
                @click="toReviewed"
                :disabled="this.executing"
              >
                <span>通過 </span>
              </b-button>
            </div>

            <!-- like -->
            <!-- <div
              class="d-flex align-items-center"
              v-if="isReviewed"
            >
              <b-icon
                class="sr__icon sr__icon-like mr-1"
                :class="{'sr__icon-like--active': liked}"
                @click="toggleLike"
                icon="heart-fill"
              ></b-icon>

              <span class="sr__icon-like-count">{{likeCount == 0 ? '' : likeCount }}</span>
            </div> -->
          </div>

        </div>

        <!-- normal comment -->
        <!-- <CommentList
          :start="getRecordComments"
          :canNewComment="isReviewed"
          :canViewComments="isReviewed"
          :addCommentLabel="'新增評論'"
          :staffId="staffId"
        >
        </CommentList> -->

      </div>

      <!-- notify modal -->
      <b-modal
        id="rsaddrecordnoti"
        ref="rsaddrecordnoti-modal"
        :title="notifyInfo.title"
      >
        <template>
          <div>
            <div
              v-for="(item, index) in notifyInfo.items"
              :key="index"
            >
              <div v-if="item.iden === 'staff_level'">
                <div class="rs-addreco-noti-content">
                  <div style="padding-bottom: 8px;"><b>夥伴資訊：</b></div>
                  <ul style="font-size: 14px">
                    <li  style="padding-bottom: 4px;">{{item.value}}</li>
                  </ul>
                </div>
              </div>

              <div v-else-if="item.iden === 'reviewer'">
                <div class="rs-addreco-noti-content">
                  <div style="padding-bottom: 8px;"><b>審核者：</b></div>
                  <ul style="font-size: 14px">
                    <li  style="padding-bottom: 4px;">{{item.value}}</li>
                  </ul>
                </div>
              </div>

              <div v-else>
                <div class="rs-addreco-noti-content" v-html="item.content">
                </div>
              </div>

            </div>
          </div>
        </template>

        <template #modal-footer="{ cancel }">
          <b-button size="sm" variant="light" @click="cancel()" style="width:100px;">
            確認
          </b-button>
        </template>
      </b-modal>

    </div>

    <!-- loading -->
    <div class="vh-100 d-flex align-items-center" v-if="pageInfo.items.length === 0">
      <span class="lds-dual-ring"></span>
    </div>

    <!-- add new comment modal -->
    <div class="modal micromodal-slide" id="review-comment-modal">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container">
          <div class="modal__content">
            <!-- review comments -->
            <ReviewCommentList
              :currentPageIden="currentPageIden"
              :canComment="canReview"
              :canReply="canReply"
              :addCommentLabel="'新增審核評論'"
              @reviewPageMenuItems="setPageMenuItems"
            >
            </ReviewCommentList>
          </div>
        </div>
      </div>
    </div>

    <!-- page menu -->
    <div>
      <div style="height: 5.25rem;"></div>

      <div
        class  = "sr-nav__menu-list"
        :class = "{'sr-nav__menu-list--open': menuOpen}"
      >
        <div
          class  = "sr-nav__menu-item"
          v-for  = "(item, idx) in pageMenuItems"
          :key   = "idx"
        >
          <div
            class  = "w-100"
            @click = "goToSetup(item.idx)"
          >
            <div class="text-cente">{{ item.label }}</div>

            <div
              class = "d-flex align-items-center w-100 justify-content-center"
              v-if  = "canEdit || canReview"
            >
              <div
                :class="{'mr-1': item.any_urc}"
                v-if="item.checked !== null"
              >
                <b-icon
                  icon  = "check-circle"
                  :style = "`color: #${item.checked ? '37d95c' : '999999'};`"
                ></b-icon>
              </div>

              <div
                class = "sr__badge sr__badge--sq sr__badge--fix"
                style = "height: 24px;"
                v-if  = "item.any_urc"
              >需修正</div>
            </div>
          </div>
        </div>
      </div>

      <div class="sr-nav__menu-box">
        <!-- menu -->
        <div
          class  = "sr-nav__menu-btn"
          :class = "{'sr-nav__menu-btn--open': menuOpen, 'w-100': !canEdit}"
          @click = "toggleMenu"
        >
          <div v-if="!menuOpen">
            <div class="d-flex align-items-center justify-content-center">
              <span class="pr-2"><b-icon icon="list"></b-icon></span>
              <span>前往頁面</span>
            </div>
          </div>
          <div v-else>
            <span><b-icon icon="x-lg"></b-icon></span>
           </div>
        </div>

        <!-- draft save button -->
        <div
          v-if   = "!menuOpen && canEdit"
          class  = "sr_draft-save-btn"
          @click = "draftSave"
          >
          <span
            v-if  = "draftSaving"
            class = "lds-dual-ring lds-dual-ring--btn"
          ></span>
          <b-icon
            v-if   = "!draftSaving"
            style  = "color: white;"
            icon   = "save"
          ></b-icon>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceRecordItem from './serviceRecordItem.vue'
import OrderItem from './orderItem.vue'
// import CommentList from './CommentList.vue'
import ReviewCommentList from './ReviewCommentList.vue'
import { successMsg, failMsg } from '../../util/msg.js'

export default {
  name: 'ServiceRecord',
  props: {
    // recordId: String,
    // lineId: String,
    // mode: String
  },
  data () {
    return {
      executing: false,
      recordId: '',
      lineId: '',
      mode: '',
      notifyInfo: {
        items: []
      },
      pageInfo: {
        items: []
      },
      pageIdens: [],
      notifyPageIden: 'notify',
      currentStep: 0,
      status: '',
      isOwner: false,
      isReviewer: false,
      modeString: '',
      liked: false,
      liking: false,
      likeCount: 0,
      getRecordComments: false,
      statusString: null,
      pageMenuItems: [],
      menuOpen: false,
      staffId: null,
      ignoreRecordReview: false,
      changingPage: false,
      draftSaving: false
    }
  },
  async created () {
    this.recordId = this.$route.params.id
    this.mode = this.$route.meta.action
    this.lineId = this.$store.state.userId
    this.pageMenuItems = []

    await this.getLikeInfo()

    this.$nextTick(async () => {
      this.pageIdens = [this.notifyPageIden]

      await this.getPageInfo(this.notifyPageIden)
      await this.goToNextStep()
    })
  },
  computed: {
    currentPageIden () {
      return this.pageIdens[this.currentStep]
    },
    isLastPage () {
      return this.currentStep === this.pageIdens.length - 1
    },
    disable () {
      return this.viewMode || this.reviewMode
    },
    viewMode () {
      return this.mode === 'view'
    },
    editMode () {
      return this.mode === 'edit'
    },
    reviewMode () {
      return this.mode === 'review'
    },
    isDraft () {
      return this.status === 'draft'
    },
    isReviewed () {
      return this.status === 'reviewed'
    },
    isReviewing () {
      return this.status === 'reviewing'
    },
    isRecheck () {
      return this.status === 'recheck'
    },
    canView () {
      return this.viewMode && (this.isOwner || this.isReviewer || this.isReviewed)
    },
    canEdit () {
      return this.editMode && this.isOwner && (this.isDraft || this.isRecheck)
    },
    canReview () {
      return this.reviewMode && this.isReviewer && this.isReviewing
    },
    canReply () {
      return this.canEdit || this.canReview
    },
    canShowTag () {
      return this.isReviewing
    }
  },
  watch: {
    async currentStep () {
      await this.getPageInfo(this.currentPageIden)
    }
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen
    },
    goToSetup (idx) {
      if (idx === null) {
        this.goToList(0)
      } else {
        this.menuOpen = false
        this.currentStep = idx
      }
    },
    async getLikeInfo () {
      const resp = await this.$api.get(this.apiUrl('like_info'))
      this.likeCount = resp.like_info.like_count
      this.liked = resp.like_info.liked
    },
    async setPageMenuItems () {
      const resp = await this.$api.get(this.apiUrl('page_menu'))
      this.pageMenuItems = resp.page_menu
      this.pageMenuItems = this.pageMenuItems.filter(e => e.iden !== this.notifyPageIden)
      this.pageMenuItems.push({ label: '回列表', idx: null, checked: null })
    },
    async toggleLike () {
      this.liking = true

      this.liked = !this.liked
      this.likeCount = this.liked ? this.likeCount + 1 : this.likeCount - 1

      await this.$api.post(this.apiUrl('like'), { liked: this.liked })
      this.liking = false
    },
    apiUrl (action) {
      return `${this.$apiDoc.staffUrlV1}/${this.lineId}/${this.$apiDoc.apiGetService}/${this.recordId}/${action}`
    },
    async getPageInfo (mainIden) {
      this.changingPage = true
      const options = { iden: mainIden }

      this.pageInfo = { items: [] }
      document.documentElement.scrollTop = 0
      try {
        const resp = await this.$api.get(this.apiUrl('page'), options)
        if (!resp.service_records) {
          throw new Error(`page ${mainIden} no data`)
        }

        this.setContext(resp.service_records)
        this.arrangePageInfo(mainIden, resp.service_records)
        await this.setPageMenuItems()

        this.changingPage = false
        return resp.service_records
      } catch (e) {
        console.error(e)

        this.changingPage = false
        return null
      }
    },
    validateItems (options = {}) {
      var uiNotify = options.uiNotify
      var validateInfo = this.$store.state.validateInfo

      if (Object.keys(validateInfo).length > 0) {
        var mins = []
        for (const [key, value] of Object.entries(validateInfo)) {
          if (!value.checkValueIsValid(uiNotify)) {
            console.log('check fail', key)
            mins.push(value.top())
          }
        }

        if (mins.length > 0) {
          if (uiNotify) {
            document.documentElement.scrollTop = Math.min(...mins) - 40
          }
          return false
        }
      }

      return true
    },
    async goToNextStep () {
      if (this.executing) {
        return
      }

      if (!this.validateItems({ uiNotify: true })) {
        return
      }

      if (this.canEdit || this.canReview) {
        this.executing = true
        await this.writePageInfo()
        this.executing = false
      }
      this.currentStep++
    },
    async draftSave () {
      if (this.executing || !this.canEdit || this.changingPage) {
        return
      }

      this.draftSaving = true
      this.executing = true

      await this.draftPageInfo()
      await this.setPageMenuItems()

      this.draftSaving = false
      this.executing = false
    },
    async goToPreStep () {
      if (this.executing) {
        return
      }

      // if (this.canEdit || this.canReview) {
      //   this.executing = true
      //   await this.writePageInfo()
      //   this.executing = false
      // }
      this.currentStep--
    },
    async toReview () {
      if (this.executing) {
        return
      }

      if (!this.validateItems()) {
        return
      }

      if (this.ignoreRecordReview) {
        var answer = confirm('履歷送審即通過，是否確定送審?')
        if (!answer) {
          return
        }
      }

      this.executing = true
      try {
        await this.writePageInfo()
        await this.$api.post(this.apiUrl('to_review'), {})
        alert('送審成功')
        this.goToList(1)
      } catch (e) {
        alert(e.response?.data?.data)
      }

      this.executing = false
    },
    async toReviewCheck () {
      if (this.executing) {
        return
      }

      var answer = confirm('確定退回?')
      if (!answer) {
        return
      }

      this.executing = true
      try {
        await this.$api.post(this.apiUrl('to_recheck'), {})
        alert('退回成功')
        this.goToList(1)
      } catch (e) {
        console.error(e)
      }

      this.executing = false
    },
    async toReviewed () {
      if (this.executing) {
        return
      }

      var answer = confirm('確定審核通過?')
      if (!answer) {
        return
      }

      this.executing = true
      try {
        await this.$api.post(this.apiUrl('to_reviewed'), {})
        alert('通過成功')
        this.goToList(1)
      } catch (e) {
        alert(e.response?.data?.data)
        console.error(e.response?.data?.data)
      }

      this.executing = false
    },
    setContext (serviceRecord) {
      this.status = serviceRecord.status
      this.isOwner = serviceRecord.is_owner
      this.isReviewer = serviceRecord.is_reviewer
      this.statusString = serviceRecord.status_string
      this.staffId = serviceRecord.staff_id
      this.ignoreRecordReview = serviceRecord.ignore_record_review

      if (!this.getRecordComments) {
        this.getRecordComments = true
      }

      if (this.reviewMode) {
        if (!this.canReview) {
          alert('無法審核')
          this.goToList(0)
        }
        this.modeString = '審核'
      } else if (this.editMode) {
        if (!this.canEdit) {
          alert('無法修改')
          this.goToList(0)
        }
        this.modeString = '修改'
      } else if (this.viewMode) {
        if (!this.canView) {
          alert('無法查看')
          this.goToList(0)
        }
        this.modeString = '查看'
      }
    },
    getPageValueItems () {
      const items = []
      this.pageInfo.items.forEach(e => {
        if (!e.editable) {
          return
        }

        items.push(this.getPageValueItem(e))
      })

      return items
    },
    getPageValueItem (item) {
      if (item.type !== 'input_mix') {
        return {
          iden: item.iden,
          type: item.type,
          uuid: item.uuid,
          value: item.value
        }
      }

      const value = []
      item.value.map(e => {
        if (!e.editable) {
          return
        }
        value.push(this.getPageValueItem(e))
      })

      return {
        iden: item.iden,
        type: item.type,
        // radio group切換選項後，若有留言的話還是會顯示需修正
        // uuid: item.uuid,
        value: value
      }
    },
    async draftPageInfo () {
      if (!this.pageInfo.review) {
        return false
      }

      const isValid = this.validateItems({ uiNotify: false })

      const body = {
        page: {
          iden: this.pageInfo.iden,
          items: this.getPageValueItems(),
          is_valid: isValid
        }
      }

      var r = false
      try {
        await this.$api.post(this.apiUrl('draft_page'), body)
        r = true
        successMsg('儲存草稿成功')
      } catch (e) {
        failMsg('儲存草稿失敗')
        console.error(e)
      }

      return r
    },
    async writePageInfo () {
      if (!this.pageInfo.review) {
        return false
      }

      const body = {
        page: {
          iden: this.pageInfo.iden,
          items: this.getPageValueItems()
        }
      }

      var r = false
      try {
        const resp = await this.$api.post(this.apiUrl('write_page'), body)
        if (!resp.service_records) {
          throw new Error('write page no step data')
        }
        this.setSteps(resp.service_records.page_idens)
        r = true
      } catch (e) {
        console.error(e)
      }

      return r
    },
    async arrangePageInfo (mainIden, serviceRecord) {
      this.setSteps(serviceRecord.page_idens)

      switch (mainIden) {
        case 'notify':
          if (this.canEdit) {
            this.notifyInfo = serviceRecord.page
            this.$bvModal.show('rsaddrecordnoti')
          }
          break
        default:
          this.pageInfo = serviceRecord.page
      }
    },
    setSteps (newPageIdens) {
      this.pageIdens = newPageIdens
    },
    goToList (reload) {
      var q = ''
      if (this.$route.query.review_scope === '1') {
        q = 'review_scope=1'
      }

      this.$router.push({ path: `/staff/service_records?${q}`, replace: true })
    }
  },
  components: {
    ServiceRecordItem,
    OrderItem,
    // CommentList,
    ReviewCommentList
  }
}
</script>

<style scoped>
  .sr_draft-save-btn {
    position: relative;
    width: 3rem;
    height: 3rem;
    background-color: #343a40;
    border-radius: 50%;
    display: flex ;
    justify-content: center;
    align-items: center;
    /* position: fixed;
    bottom: 4.5rem;
    right: 1rem; */
    box-shadow: 9px 12px 9px -5px rgba(0, 0, 0, 0.1);
  }

  #review-comment-modal .modal__container {
    background-color: #f7f7f7;
    max-height: 85%;
  }

  .sr-nav__menu-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    margin: 1.25rem;
    z-index: 20;
    justify-content: space-between;
    align-items: center;
  }

  .sr-nav__menu-btn {
    display: flex;
    align-items: center;
    width: 85%;
    color: #fff;
    background-color: #343a40;
    font-size: 1rem;
    letter-spacing: .2em;
    height: 2.75rem;
    display: inline-block;
    padding: .5rem 1.5rem;
    margin: 0;
    text-decoration: none;
    text-align: center;
    vertical-align: middle;
    white-space: normal;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 35px;
  }

  .sr-nav__menu-btn--open {
    width: 100%;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  .sr-nav__menu-list {
    padding: .5rem 0;
    display: none;
    position: fixed;
    bottom: 2.75rem;
    left: 0;
    right: 0;
    margin: 1.25rem;
    z-index: 20;
    max-height: 36rem;
    overflow: auto;

    color: #fff;
    background-color: #343a40;
  }

  /* custom scrollbar */
  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }

  .sr-nav__menu-list--open {
    border-top-right-radius: 35px;
    border-top-left-radius: 35px;
    display: block;
  }

  .sr-nav__menu-item {
    width: 100%;
    padding: .75rem;
    text-align: center;
    font-size: 1rem;
    letter-spacing: .2em;
    cursor: pointer;
  }

</style>
